export default "__VITE_ASSET__DkyVpkpX__"